import { gql } from '@apollo/client'

export const GET_PRICE_LIST = gql`
  query pricingPlan($id: ID!) {
    node(id: $id) {
      ... on PricingPlan {
        id
        name
        default
        pricings {
          id
          target
          startDate
          endDate
          mediaFormatOfferPricings {
            id
            mediaFormat
            offer
            valueCents
          }
        }
      }
    }
  }
`
